<template>
  <!-- <div class="navigator">
    <ul>
      <li>
        <router-link to="/management-details/document-config/document-categories">
          <i class="fa-solid fa-layer-group"></i>
          <span>Document Categories</span>
        </router-link>
      </li>
      <li>
        <router-link to="/management-details/document-config/documents">
          <i class="fa-solid fa-file-lines"></i>
          <span>Documents</span>
        </router-link>
      </li>
    </ul>
  </div> -->

  <!-- <div class="container">
    <router-view></router-view>
  </div> -->
  <router-view></router-view>
</template>

<script>
export default {
  mounted () {
    // Automatically navigate to Document Categories when the component is mounted
    this.redirectToCategories()
  },
  watch: {
    // Watch for changes in the route
    $route (to, from) {
      // If the current route is the main document config page, redirect to categories
      if (to.path === '/management-details/document-config') {
        this.redirectToCategories()
      }
    }
  },
  methods: {
    redirectToCategories () {
      this.$router.push('/management-details/document-config/document-categories')
    }
  }
}
</script>

<style scoped>
  .navigator {
    width: 100%;
    background: #0480cc;
    height: 68px;
  }

  ul {
    display: flex;
    justify-content: space-around;
    padding: 15px;
  }

  ul li {
    list-style: none;
    border-radius: 12px;
    padding: 7px;
  }

  ul li a {
    color: white;
    font-size: 18px;
    text-decoration: none;
    padding: 7px 10px;
    border-radius: 12px;
  }

  ul li a i {
    margin-right: 20px;
  }

  ul li a:hover{
    background: rgba(207, 149, 49, 0.7);
  }

  ul li a.router-link-exact-active {
    background: rgba(207, 149, 49, 0.9);
  }

  .container {
    margin-top: 20px;
  }
</style>
